import React from "react";
import ReactDom from "react-dom";
import PropTypes from "prop-types";
import { Panel } from "react-bootstrap";
import Materialicon from "../helpers/Materialicon";

export default class SubPages extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
		};
	}
	render() {
		const listSub = this.props.children.map((link, i) => (
			<li key={link.props.itemID}>
				<Materialicon icon="chevron_right" /> {link}
			</li>
		));
		return (
			<div className="item-subpage">
				<button onClick={() => this.setState({ open: !this.state.open })} data-expanded={this.state.open}>
					<Materialicon icon={this.props.icon} />
					<span className="nav-name">{this.props.title}</span>
					<span className="array_left"><Materialicon icon="keyboard_arrow_left" /></span>
				</button>
				<Panel collapsible expanded={this.state.open}>
					<ul>
						{listSub}
					</ul>
				</Panel>
			</div>
		);
	}
}
SubPages.propTypes = {
	children: PropTypes.arrayOf(PropTypes.shape({
		link: PropTypes.string
	})).isRequired,
	icon: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired
};


// WEBPACK FOOTER //
// ./src/components/navigation/SubPages.js